import type { ComponentType } from 'react';

import { withOktaAuth } from '@okta/okta-react';
import { connect } from 'react-redux';

import { trackEvent } from '../app/AppActions';

import Routes from './Routes';

function mapDispatchToProps() {
  return {
    trackFatalError: (errorInfo: any) => {
      trackEvent('user.application.fatal.error', { ...errorInfo });
    },
  };
}

function mapStateToProps(state: any) {
  const {
    login: { user },
  } = state;

  return {
    user,
  };
}

const RoutesContainer: ComponentType<any> = withOktaAuth(
  // @ts-expect-error TS(2345): Argument of type 'ConnectedComponent<{ (props: any... Remove this comment to see the full error message
  connect(mapStateToProps, mapDispatchToProps)(Routes),
);

export default RoutesContainer;
